import React from "react";
import { Link } from "react-router-dom";
import * as Routes from "../../Utils/Routes";
import NavLink from "./NavLink";

export default class NavBar extends React.Component {
  render() {
    return (
      <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <Link className="navbar-brand" to={Routes.HOME}>
          Dungeon World
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon" />
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav mr-auto">
            {this.link(Routes.HOME, "Hjem")}
            {this.link(Routes.MONSTERS, "Monstre")}
            {this.link(Routes.NOTES, "Noter")}
          </ul>
        </div>
      </nav>
    );
  }

  private link = (path: string, text: string) => (
    <NavLink route={path} text={text} active={false} />
  );
}
